import ApiService from '../../api/ApiService';
import {DialogCallbacks} from '../../types/common';
import {dispatchAsync} from '../common';
import types from './types';
import api from '../../api';
import {action} from 'redux/helpers';
import {ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';
import {State} from 'redux/reducer';
import {pageSelectors} from 'features/layout/CommonPage/redux';
import {DiplomatObjectTypeUnion} from 'types/DiplomatObjectType';
import {IPartner} from 'types/Partner';

const movePartner = (partnerIds: string[], folderId: string, cbs?: DialogCallbacks) =>
   dispatchAsync(api.partnerMove, types.MOVE_PARTNER, {
      ...cbs,
      getMethod: ApiService.postSecureJson,
      data: {
         partnerIds,
         folderId,
      },
   });

const releasePartner = (data: any) => action(types.RELEASE_PARTNER, data);
const suspendPartner = (data: any) => action(types.SUSPEND_PARTNER, data);

const saveAs = (
   id: string,
   objectType: DiplomatObjectTypeUnion,
   name: string,
   _partner?: IPartner,
   options?: {
      onSuccess?: (data: IPartner) => void;
      onFailure?: (error: any) => void;
   }
) => async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => Promise<State>) => {
   const state = await getState();
   const currentObject = pageSelectors.getData(state);
   let partner = _partner || currentObject;
   if (!_partner && (id !== currentObject.id || objectType !== currentObject.objectType)) {
      partner = await dispatch(dispatchAsync(`${api.partners}/${id}`, types.GET_PARTNER));
   }

   if (!partner) {
      console.error('Partner is null, "Clone" failed', id, objectType, name);
   }

   const newPartner = {...partner, name, anonymous: false};
   return dispatch(
      dispatchAsync(api.partners, types.CREATE_PARTNER, {
         getMethod: ApiService.postSecureJson,
         data: {
            partner: newPartner,
            folderId: newPartner.folderId,
            overwrite: false,
         },
         onSuccess: options?.onSuccess,
         onError: options?.onFailure,
      })
   );
};

export default {
   movePartner,
   saveAs,
   releasePartner,
   suspendPartner,
   getRefsPgp: (id: string, cbs?: DialogCallbacks) =>
      dispatchAsync(`${api.partnersRefsPgp}/${id}`, types.GET_REFS_PGP, {
         ...cbs,
      }),
   getRefsSsh: (id: string, cbs?: DialogCallbacks) =>
      dispatchAsync(`${api.partnersRefsSsh}/${id}`, types.GET_REFS_SSH, {
         ...cbs,
      }),
   getRefsSsl: (id: string, cbs?: DialogCallbacks) =>
      dispatchAsync(`${api.partnersRefsSsl}/${id}`, types.GET_REFS_SSL, {
         ...cbs,
      }),
   getRefsProxy: (id: string, cbs?: DialogCallbacks) =>
      dispatchAsync(`${api.partnersRefsProxy}/${id}`, types.GET_REFS_PROXY, {
         ...cbs,
      }),
};
